var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"top-tab"},[(_vm.$route.name!='Login')?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notShow),expression:"notShow"}],staticClass:"right-userinfo"},[_c('userinfo')],1):_vm._e()]),_c('div',{staticClass:"content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }